var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V300H300V0H0ZM100.716 238.295H65.5169V115.42H100.715V238.295H100.716ZM83.4637 101.408C71.6574 101.408 62.053 92.5021 62.053 81.5562C62.053 70.6103 71.6587 61.7044 83.4637 61.7044C95.2688 61.7044 104.875 70.6103 104.875 81.5562C104.875 92.5021 95.2688 101.408 83.4637 101.408ZM237.947 238.295H201.883V165.421C201.89 165.274 202.417 153.704 195.857 146.794C192.593 143.353 188.095 141.608 182.489 141.608C168.385 141.608 161.262 151.764 158.243 157.914V238.295H123.044V115.42H158.242V125.801C169.764 116.453 182.704 111.522 195.744 111.522C229.127 111.522 237.947 137.598 237.947 151.386V238.295Z",
    fill: "#0057b8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLn);
export default __webpack_public_path__ + "static/media/ln.ce8f0cb6139ca2cfaf47e0201176f0a3.svg";
export { ForwardRef as ReactComponent };